import api from "../../Hooks/axiosApi";

// 🔹 Create / Upload Training Doc
export const createTrainingDocService = (data: any) => {
    return api.post("/api/CrmTraining/createtrainingdocs", data, {
        headers: { "Content-Type": "multipart/form-data" }
    });
};

// 🔹 Update Training Doc (can also replace file)
export const updateTrainingDocService = (data: any) => {
    return api.put("/api/CrmTraining/updatetrainingdocs", data, {
        headers: { "Content-Type": "multipart/form-data" }
    });
};

// 🔹 Get All Training Docs
export const getAllTrainingDocsService = () => {
    return api.get("/api/CrmTraining/get-alltrainingdocs");
};

// 🔹 Get Training Doc by Id
export const getTrainingDocByIdService = (id: any) => {
    return api.get(`/api/CrmTraining/get-by-idtrainingdocs/${id}`);
};

// 🔹 Delete Training Doc (soft delete)
export const deleteTrainingDocService = (id: any) => {
    return api.delete(`/api/CrmTraining/deletetrainingdocs/${id}`);
};
// 🔹 Soft Delete Training Doc (only send Id)


